/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {StackedSymbol} from "../core/reel/stackedsymbol/StackedSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRip} from "./DeadwoodRip";

export class DeadwoodRipGameConfig {

    // Win
    public static WIN_RATIOS:IWinRatioConfig[] = [
        {
            ratio : 0,
            name : "Tiny Win",
            duration : 0,
            winLevel : 0,
            bigWinLevel : -1
        },
        {
            ratio : 1,
            startRatioExcluded : true,
            name : "Small Win",
            duration : 0,
            winLevel : 1,
            bigWinLevel : -1
        },
        {
            ratio : 3,
            name : "Medium Win",
            duration : 0.4,
            winLevel : 2,
            bigWinLevel : -1
        },
        {
            ratio : 5,
            name : "Large Win",
            duration : 0.8,
            winLevel : 3,
            bigWinLevel : -1
        },
        {
            ratio : 15,
            name : "Big Win 1",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 0
        },
        {
            ratio : 25,
            name : "Big Win 2",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 1

        },
        {
            ratio : 50,
            name : "Big Win 3",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 2
        },
        {
            ratio : 100,
            name : "Big Win 4",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 3
        },
        {
            ratio : 500,
            name : "Big Win 5",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 4
        },
        {
            ratio : 1000,
            name : "Big Win 6",
            duration : 7.67,
            winLevel : 4,
            bigWinLevel : 5
        }
    ];

    public static WIN_CAP_RATIO:number = 100000;

    public static REEL_SETS:IReelSets = {
        "NORMAL_REELSET" : [
            ["M2", "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4",
                "L1", "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "C",
                "L1", "L5", "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2", "M4", "M2",
                "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4", "L1",
                "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "L1", "L5",
                "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2"],
            ["M4", "L5", "L2", "S1", "M1", "L1", "L2", "L4", "S1", "L5", "L1", "M2", "L4", "L1", "M1", "L4", "L1", "M2",
                "L3", "L1", "M3", "L4", "L3", "M4", "M5", "L5", "L1", "M2", "L2", "WXN", "WXN", "WXN", "WXN", "L5", "M2",
                "L2", "L3", "M5", "L4", "L5", "M5", "L1", "L4", "M1", "L3", "L4", "L3", "L1", "L3", "M1", "L4", "L2", "M2",
                "L5", "L3", "M3", "L5", "L3", "M5", "L2", "S3", "M3", "M2", "L4", "M2", "L1", "L4", "M4", "L2", "L4"],
            ["M5", "L4", "L5", "M3", "M3", "L2", "L1", "L3", "L5", "M4", "L2", "L5", "M3", "L1", "L4", "S1", "L2", "L5",
                "M1", "L4", "L3", "M1", "L2", "L2", "M3", "L3", "L4", "M1", "L5", "L3", "M5", "L2", "L5", "M4", "L3", "L4",
                "M2", "L1", "L4", "M4", "L1", "L4", "M3", "L4", "L1", "M3", "L3", "L5", "M4", "L4", "L3", "M5", "L1", "L5",
                "M4", "L3", "L5", "M1", "L2", "L3", "M3", "WXN", "WXN", "WXN", "WXN", "L5", "L2", "M5", "L5", "L4", "M2",
                "L3", "L5", "L2", "L1", "M5", "L4", "L5", "M2", "M3", "L4", "M5", "L3", "L5", "M4", "M4", "L1", "L5", "L3",
                "L5", "M1", "L4", "L2", "M2", "L3", "L4", "M3", "L5", "L3", "M1", "L5", "L3", "M3", "M3", "L5", "M5", "L1",
                "L5", "M4", "L1", "L5", "M2", "L3", "L5", "M1", "L2", "M4", "L4", "L3", "M5", "L5", "L4", "M4", "L2", "L3",
                "M5", "L5", "L3", "M4", "M4", "L4", "M2", "L2", "L3", "L4", "M2", "L2", "L3", "S1", "L4", "L5"],
            ["M4", "L3", "L4", "S1", "L3", "L4", "M1", "L2", "L5", "M4", "L2", "L4", "M1", "L1", "L4", "M2", "L2", "L3",
                "M4", "L2", "L3", "S1", "L4", "M3", "L1", "L2", "M4", "L1", "L2", "M3", "L5", "S3", "M2", "L4", "L5", "WXN",
                "WXN", "WXN", "WXN", "M5", "L4", "L5", "M2", "L2", "L3", "M1", "L3", "L4", "L5", "L3", "M4", "L3", "L1",
                "L3", "L1", "M3", "L2", "L1", "M1", "L1", "M4", "L5", "L2", "M2", "L5", "M5", "L1", "L2", "M2", "L4", "L3",
                "M2", "L2", "L5"],
            ["M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "S2", "S2", "M1", "M1", "M2", "M2", "M3", "M3",
                "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2",
                "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5"],
        ],
        "XBET1_NORMAL_REELSET" : [
            ["M2", "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4",
                "L1", "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "C",
                "L1", "L5", "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2", "M4", "M2",
                "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4", "L1",
                "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "L1", "L5",
                "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2"],
            ["S1", "M1", "L5", "L2", "S1", "M2", "L1", "L2", "S1", "M3", "L1", "L4", "S1", "M4", "L5", "L1", "S1", "M5",
                "L4", "L1", "S1", "M2", "L4", "L1", "S1", "L4", "L3", "L1", "S1", "L2", "L4", "L3", "S1", "L3", "L5", "L1",
                "S1", "M1", "L2", "L5", "S1", "M3", "L2", "L3", "S1", "M5", "L4", "L5", "S1", "M1", "L1", "L4", "S1", "M2",
                "L3", "L4", "S1", "M3", "L1", "L3", "S1", "M4", "L4", "M2", "S1", "M5", "L5", "L3", "S1", "M5", "L5", "L3",
                "S1", "M4", "L2", "L4", "S1", "M4", "L5", "L4", "S1", "M3", "L1", "L4", "S1", "M3", "L2", "L4"],
            ["M5", "L4", "L5", "M3", "M3", "L2", "L1", "L3", "L5", "M4", "L2", "L5", "M3", "L1", "L4", "S1", "L2", "L5",
                "M1", "L4", "L3", "M1", "L2", "L2", "M3", "L3", "L4", "M1", "L5", "L3", "M5", "L2", "L5", "M4", "L3", "L4",
                "M2", "L1", "L4", "M4", "L1", "L4", "M3", "L4", "L1", "M3", "L3", "L5", "M4", "L4", "L3", "M5", "L1", "L5",
                "M4", "L3", "L5", "M1", "L2", "L3", "M3", "WXN", "WXN", "WXN", "WXN", "L5", "L2", "M5", "L5", "L4", "M2",
                "L3", "L5", "L2", "L1", "M5", "L4", "L5", "M2", "M3", "L4", "M5", "L3", "L5", "M4", "M4", "L1", "L5", "L3",
                "L5", "M1", "L4", "L2", "M2", "L3", "L4", "M3", "L5", "L3", "M1", "L5", "L3", "M3", "M3", "L5", "M5", "L1",
                "L5", "M4", "L1", "L5", "M2", "L3", "L5", "M1", "L2", "M4", "L4", "L3", "M5", "L5", "L4", "M4", "L2", "L3",
                "M5", "L5", "L3", "M4", "M4", "L4", "M2", "L2", "L3", "L4", "M2", "L2", "L3", "S1", "L4", "L5"],
            ["M4", "L3", "L4", "S1", "L3", "L4", "M1", "L2", "L5", "M4", "L2", "L4", "M1", "L1", "L4", "M2", "L2", "L3",
                "M4", "L2", "L3", "S1", "L4", "M3", "L1", "L2", "M4", "L1", "L2", "M3", "L5", "S3", "M2", "L4", "L5", "WXN",
                "WXN", "WXN", "WXN", "M5", "L4", "L5", "M2", "L2", "L3", "M1", "L3", "L4", "L5", "L3", "M4", "L3", "L1",
                "L3", "L1", "M3", "L2", "L1", "M1", "L1", "M4", "L5", "L2", "M2", "L5", "M5", "L1", "L2", "M2", "L4", "L3",
                "M2", "L2", "L5"],
            ["M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "S2", "S2", "M1", "M1", "M2", "M2", "M3", "M3",
                "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2",
                "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5"]
        ],
        "XBET2_NORMAL_REELSET" : [
            ["M2", "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4",
                "L1", "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "C",
                "L1", "L5", "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2", "M4", "M2",
                "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4", "L1",
                "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "L1", "L5",
                "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2"],
            ["S1", "M1", "L5", "L2", "S1", "M2", "L1", "L2", "S1", "M3", "L1", "L4", "S1", "M4", "L5", "L1", "S1", "M5",
                "L4", "L1", "S1", "M2", "L4", "L1", "S1", "L4", "L3", "L1", "S1", "L2", "L4", "L3", "S1", "L3", "L5", "L1",
                "S1", "M1", "L2", "L5", "S1", "M3", "L2", "L3", "S1", "M5", "L4", "L5", "S1", "M1", "L1", "L4", "S1", "M2",
                "L3", "L4", "S1", "M3", "L1", "L3", "S1", "M4", "L4", "M2", "S1", "M5", "L5", "L3", "S1", "M5", "L5", "L3",
                "S1", "M4", "L2", "L4", "S1", "M4", "L5", "L4", "S1", "M3", "L1", "L4", "S1", "M3", "L2", "L4"],
            ["S1", "M1", "L5", "L2", "S1", "M2", "L1", "L2", "S1", "M3", "L1", "L4", "S1", "M4", "L5", "L1", "S1", "M5",
                "L4", "L1", "S1", "M2", "L4", "L1", "S1", "L4", "L3", "L1", "S1", "L2", "L4", "L3", "S1", "L3", "L5", "L1",
                "S1", "M1", "L2", "L5", "S1", "M3", "L2", "L3", "S1", "M5", "L4", "L5", "S1", "M1", "L1", "L4", "S1", "M2",
                "L3", "L4", "S1", "M3", "L1", "L3", "S1", "M4", "L4", "M2", "S1", "M5", "L5", "L3", "S1", "M5", "L5", "L3",
                "S1", "M4", "L2", "L4", "S1", "M4", "L5", "L4", "S1", "M3", "L1", "L4", "S1", "M3", "L2", "L4"],
            ["M4", "L3", "L4", "S1", "L3", "L4", "M1", "L2", "L5", "M4", "L2", "L4", "M1", "L1", "L4", "M2", "L2", "L3",
                "M4", "L2", "L3", "S1", "L4", "M3", "L1", "L2", "M4", "L1", "L2", "M3", "L5", "S3", "M2", "L4", "L5", "WXN",
                "WXN", "WXN", "WXN", "M5", "L4", "L5", "M2", "L2", "L3", "M1", "L3", "L4", "L5", "L3", "M4", "L3", "L1", "L3",
                "L1", "M3", "L2", "L1", "M1", "L1", "M4", "L5", "L2", "M2", "L5", "M5", "L1", "L2", "M2", "L4", "L3", "M2",
                "L2", "L5"],
            ["M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "S2", "S2", "M1", "M1", "M2", "M2", "M3", "M3",
                "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2",
                "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5"],
        ],
        "FREESPIN_REELSET" : [
            ["M2", "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4",
                "L1", "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "C",
                "L1", "L5", "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2", "M4", "M2",
                "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4", "L1",
                "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "L1", "L5",
                "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2"],
            ["M4", "L5", "L2", "S1", "M1", "L1", "L2", "L4", "S1", "L5", "L1", "M2", "L4", "L1", "M1", "L4", "L1", "M2",
                "L3", "L1", "M3", "L4", "L3", "M4", "M5", "L5", "L1", "M2", "L2", "WXN", "WXN", "WXN", "WXN", "L5", "M2",
                "L2", "L3", "M5", "L4", "L5", "M5", "L1", "L4", "M1", "L3", "L4", "L3", "L1", "L3", "M1", "L4", "L2", "M2",
                "L5", "L3", "M3", "L5", "L3", "M5", "L2", "S3", "M3", "M2", "L4", "M2", "L1", "L4", "M4", "L2", "L4"],
            ["M5", "L4", "L5", "M3", "M3", "L2", "L1", "L3", "L5", "M4", "L2", "L5", "M3", "L1", "L4", "S1", "L2", "L5",
                "M1", "L4", "L3", "M1", "L2", "L2", "M3", "L3", "L4", "M1", "L5", "L3", "M5", "L2", "L5", "M4", "L3", "L4",
                "M2", "L1", "L4", "M4", "L1", "L4", "M3", "L4", "L1", "M3", "L3", "L5", "M4", "L4", "L3", "M5", "L1", "L5",
                "M4", "L3", "L5", "M1", "L2", "L3", "M3", "WXN", "WXN", "WXN", "WXN", "L5", "L2", "M5", "L5", "L4", "M2",
                "L3", "L5", "L2", "L1", "M5", "L4", "L5", "M2", "M3", "L4", "M5", "L3", "L5", "M4", "M4", "L1", "L5", "L3",
                "L5", "M1", "L4", "L2", "M2", "L3", "L4", "M3", "L5", "L3", "M1", "L5", "L3", "M3", "M3", "L5", "M5", "L1",
                "L5", "M4", "L1", "L5", "M2", "L3", "L5", "M1", "L2", "M4", "L4", "L3", "M5", "L5", "L4", "M4", "L2", "L3",
                "M5", "L5", "L3", "M4", "M4", "L4", "M2", "L2", "L3", "L4", "M2", "L2", "L3", "S1", "L4", "L5"],
            ["M4", "L3", "L4", "S1", "L3", "L4", "M1", "L2", "L5", "M4", "L2", "L4", "M1", "L1", "L4", "M2", "L2", "L3",
                "M4", "L2", "L3", "S1", "L4", "M3", "L1", "L2", "M4", "L1", "L2", "M3", "L5", "S3", "M2", "L4", "L5", "WXN",
                "WXN", "WXN", "WXN", "M5", "L4", "L5", "M2", "L2", "L3", "M1", "L3", "L4", "L5", "L3", "M4", "L3", "L1", "L3",
                "L1", "M3", "L2", "L1", "M1", "L1", "M4", "L5", "L2", "M2", "L5", "M5", "L1", "L2", "M2", "L4", "L3", "M2",
                "L2", "L5"],
            ["M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "S2", "S2", "M1", "M1", "M2", "M2", "M3", "M3",
                "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2",
                "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5"]
        ],
        "FREESPIN_SUPER_REELSET" : [
            ["M2", "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4",
                "L1", "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "C",
                "L1", "L5", "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2", "M4", "M2",
                "L3", "L4", "M1", "L2", "L2", "L4", "M3", "L2", "L4", "M1", "L1", "L4", "M3", "M4", "L3", "L5", "M4", "L1",
                "L4", "M2", "L3", "L2", "M5", "L2", "M5", "L1", "L2", "M1", "L4", "L3", "M3", "M2", "L4", "L4", "L1", "L5",
                "M3", "L1", "L5", "M4", "L1", "L1", "M1", "L4", "M5", "L3", "L3", "M5", "L5", "L2"],
            ["M4", "L5", "L2", "S1", "M1", "L1", "L2", "L4", "S1", "L5", "L1", "M2", "L4", "L1", "M1", "L4", "L1", "M2",
                "L3", "L1", "M3", "L4", "L3", "M4", "M5", "L5", "L1", "M2", "L2", "WXN", "WXN", "WXN", "WXN", "L5", "M2",
                "L2", "L3", "M5", "L4", "L5", "M5", "L1", "L4", "M1", "L3", "L4", "L3", "L1", "L3", "M1", "L4", "L2", "M2",
                "L5", "L3", "M3", "L5", "L3", "M5", "L2", "S3", "M3", "M2", "L4", "M2", "L1", "L4", "M4", "L2", "L4"],
            ["M5", "L4", "L5", "M3", "M3", "L2", "L1", "L3", "L5", "M4", "L2", "L5", "M3", "L1", "L4", "S1", "L2", "L5",
                "M1", "L4", "L3", "M1", "L2", "L2", "M3", "L3", "L4", "M1", "L5", "L3", "M5", "L2", "L5", "M4", "L3", "L4",
                "M2", "L1", "L4", "M4", "L1", "L4", "M3", "L4", "L1", "M3", "L3", "L5", "M4", "L4", "L3", "M5", "L1", "L5",
                "M4", "L3", "L5", "M1", "L2", "L3", "M3", "WXN", "WXN", "WXN", "WXN", "L5", "L2", "M5", "L5", "L4", "M2",
                "L3", "L5", "L2", "L1", "M5", "L4", "L5", "M2", "M3", "L4", "M5", "L3", "L5", "M4", "M4", "L1", "L5", "L3",
                "L5", "M1", "L4", "L2", "M2", "L3", "L4", "M3", "L5", "L3", "M1", "L5", "L3", "M3", "M3", "L5", "M5", "L1",
                "L5", "M4", "L1", "L5", "M2", "L3", "L5", "M1", "L2", "M4", "L4", "L3", "M5", "L5", "L4", "M4", "L2", "L3",
                "M5", "L5", "L3", "M4", "M4", "L4", "M2", "L2", "L3", "L4", "M2", "L2", "L3", "S1", "L4", "L5"],
            ["M4", "L3", "L4", "S1", "L3", "L4", "M1", "L2", "L5", "M4", "L2", "L4", "M1", "L1", "L4", "M2", "L2", "L3",
                "M4", "L2", "L3", "S1", "L4", "M3", "L1", "L2", "M4", "L1", "L2", "M3", "L5", "S3", "M2", "L4", "L5", "WXN",
                "WXN", "WXN", "WXN", "M5", "L4", "L5", "M2", "L2", "L3", "M1", "L3", "L4", "L5", "L3", "M4", "L3", "L1",
                "L3", "L1", "M3", "L2", "L1", "M1", "L1", "M4", "L5", "L2", "M2", "L5", "M5", "L1", "L2", "M2", "L4", "L3",
                "M2", "L2", "L5"],
            ["M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "S2", "S2", "M1", "M1", "M2", "M2", "M3", "M3",
                "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2",
                "M3", "M3", "M4", "M4", "M5", "M5", "M1", "M1", "M2", "M2", "M3", "M3", "M4", "M4", "M5", "M5"]
        ]
    };

    public static getReelSetName(mode:string):string {
        let xBet = "";
        if(mode === GameMode.NORMAL && DeadwoodRip.xBetController.selectedIndex > 0) {
            xBet = `XBET${DeadwoodRip.xBetController.selectedIndex}_`;
        }
        return `${xBet}${mode}_REELSET`;
    }

    public static updateReelSets():void {
        // Filter stacked symbols on REEL_SETS if any.
        for(let reelSetKey in this.REEL_SETS) {
            this.REEL_SETS[reelSetKey].forEach((reelSet:string[], reelId:number) => {
                if(reelId === 4) {
                    this.REEL_SETS[reelSetKey][reelId] = this.filterDoubleSizedSymbolReelSet(this.REEL_SETS[reelSetKey][reelId]);
                }
                this.REEL_SETS[reelSetKey][reelId] = StackedSymbol.filterStackedSymbolsReelSet(this.REEL_SETS[reelSetKey][reelId], reelId);
            });
        }
    }

    public static filterDoubleSizedSymbolReelSet(reelSet:string[]):string[] {
        const result:string[] = [];
        reelSet.forEach(sym => {
            if(sym.includes("M") || sym.includes("L")) {
                result.push(`${sym}D`);
                return;
            }
            result.push(sym);
        });
        return result;
    }
}